import type { RouteRecordRaw } from 'vue-router';

export const errorRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/admin',
    meta: { permission: null, data_scope: null },
  },
  {
    path: '/denied',
    name: 'error.denied',
    component: () => import('./denied.vue'),
    meta: { permission: null, data_scope: null, title: '无访问权限' },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'error.not-found',
    component: () => import('./notFound.vue'),
    meta: { permission: null, data_scope: null, title: '页面不存在' },
  },
];
